<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader class="object-header">
            <CRow>
                <CCol>
                    <h1 class="page__title">{{ $t(titlePage) }}</h1>
                </CCol>
                <CCol>
                    <ButtonCreate
                        :title="$t('Create delivery campaign')"
                        @click="
                            $router.push({
                                name: 'view_delivery_campaings',
                            })
                        "
                    >
                        {{ $t("Create delivery campaign") }}
                    </ButtonCreate>
                </CCol>
            </CRow>
            <!-- Title page  -->
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <!-- Filter -->
                <CRow class="justify-content-end p-2 mb-4">
                    <CCol md="6">
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.delivery_campaigns.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow
                    v-show="
                        hasItemsInTable({
                            tableName: 'delivery_campaigns',
                        })
                    "
                >
                    <CCol xl="12" md="12">
                        <CCard>
                            <CCardHeader>
                                <div class="d-flex">
                                    <TableSettings
                                        :allFields="
                                            tables.delivery_campaigns.allFields
                                        "
                                        :activeFields.sync="
                                            tables.delivery_campaigns.fields
                                        "
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <CCTable
                                    :addTableClasses="['table--sm']"
                                    :items="tables.delivery_campaigns.items"
                                    :fields="tables.delivery_campaigns.fields"
                                    :columnFilterValue.sync="
                                        tables.delivery_campaigns
                                            .columnFilterValue
                                    "
                                    :sorterValue.sync="
                                        tables.delivery_campaigns.sorterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @update:sorter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="
                                        tables.delivery_campaigns.rows
                                    "
                                    v-bind="tables.delivery_campaigns"
                                >
                                    <template #over-table>
                                        <CContainer :fluid="true">
                                            <CRow alignHorizontal="start">
                                                <CDropdown
                                                    color="primary"
                                                    :toggler-text="
                                                        $t('actions')
                                                    "
                                                    class="m-2"
                                                    :disabled="
                                                        tables
                                                            .delivery_campaigns
                                                            .itemSelected ===
                                                        null
                                                    "
                                                >
                                                    <CDropdownItem
                                                        @click="
                                                            $router.push({
                                                                name: 'delivery_campaign_details',
                                                                params: {
                                                                    uuid: tables
                                                                        .delivery_campaigns
                                                                        .itemSelected
                                                                        .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        {{ $t("details") }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        @click="
                                                            $router.push({
                                                                name: 'delivery_campaigns_leads',
                                                                params: {
                                                                    uuid: tables
                                                                        .delivery_campaigns
                                                                        .itemSelected
                                                                        .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        {{ $t("leads") }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        @click="
                                                            $router.push({
                                                                name: 'update_delivery_campaign',
                                                                query: {
                                                                    view_type:
                                                                        'edit',
                                                                },
                                                                params: {
                                                                    uuid: tables
                                                                        .delivery_campaigns
                                                                        .itemSelected
                                                                        .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        {{
                                                            $t("edit_campaing")
                                                        }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        @click="
                                                            $router.push({
                                                                name: 'delivery_pending',
                                                                params: {
                                                                    uuid: tables
                                                                        .delivery_campaigns
                                                                        .itemSelected
                                                                        .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        {{
                                                            $t(
                                                                "delivery_pending"
                                                            )
                                                        }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        @click="
                                                            archiveCampaign(
                                                                tables
                                                                    .delivery_campaigns
                                                                    .itemSelected
                                                            )
                                                        "
                                                    >
                                                        {{
                                                            $t(
                                                                "archive_campaign"
                                                            )
                                                        }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        @click="
                                                            reCalculateStatistics(
                                                                tables
                                                                    .delivery_campaigns
                                                                    .itemSelected
                                                            )
                                                        "
                                                    >
                                                        {{ $t("recalculate") }}
                                                    </CDropdownItem>
                                                     <CDropdownItem
                                                        @click="
                                                            $router.push({
                                                                name: 'delivery_campaigns_imports',
                                                                params: {
                                                                    uuid: tables
                                                                        .delivery_campaigns
                                                                        .itemSelected
                                                                        .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        {{ $t("Imports") }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        @click="
                                                            sendWorkflowPassword(
                                                                tables
                                                                    .delivery_campaigns
                                                                    .itemSelected
                                                            )
                                                        "
                                                    >
                                                        {{
                                                            $t("Send password")
                                                        }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        @click="
                                                            sendWorkflowTest(
                                                                tables
                                                                    .delivery_campaigns
                                                                    .itemSelected
                                                            )
                                                        "
                                                    >
                                                        {{ $t("Send test") }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        @click="
                                                            sendWorkflowPendings(
                                                                tables
                                                                    .delivery_campaigns
                                                                    .itemSelected
                                                            )
                                                        "
                                                    >
                                                        {{
                                                            $t(
                                                                "Send workflow pendings"
                                                            )
                                                        }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        @click="
                                                            startOrStopCampaign(
                                                                tables
                                                                    .delivery_campaigns
                                                                    .itemSelected
                                                            )
                                                        "
                                                    >
                                                        {{
                                                            tables
                                                                .delivery_campaigns
                                                                .itemSelected &&
                                                            stringToBoolean(
                                                                tables
                                                                    .delivery_campaigns
                                                                    .itemSelected
                                                                    .active
                                                            )
                                                                ? $t("stop")
                                                                : $t("start")
                                                        }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        @click="
                                                            cloneCampaign(
                                                                tables
                                                                    .delivery_campaigns
                                                                    .itemSelected
                                                            )
                                                        "
                                                    >
                                                        {{ $t("clone") }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        @click="
                                                            $router.push({
                                                                name: 'delivery_workflow_reports',
                                                                params: {
                                                                    uuid: tables
                                                                        .delivery_campaigns
                                                                        .itemSelected
                                                                        .uuid,
                                                                },
                                                            })
                                                        "
                                                    >
                                                        {{
                                                            $t(
                                                                "Workflow reports"
                                                            )
                                                        }}
                                                    </CDropdownItem>
                                                    <CDropdownItem
                                                        @click="
                                                            configureWebservice(
                                                                tables
                                                                    .delivery_campaigns
                                                                    .itemSelected
                                                            )
                                                        "
                                                    >
                                                        {{
                                                            tables
                                                                .delivery_campaigns
                                                                .itemSelected &&
                                                            tables
                                                                .delivery_campaigns
                                                                .itemSelected
                                                                .wsRelation
                                                                ? $t(
                                                                      "Update workflow"
                                                                  )
                                                                : $t(
                                                                      "Create workflow" 
                                                                  )
                                                        }}
                                                    </CDropdownItem>
                                                </CDropdown>
                                            </CRow>
                                        </CContainer>
                                    </template>
                                    <template #_selected="{ item }">
                                        <CInputRadio
                                            name="_selected"
                                            :checked="
                                                item ===
                                                tables.delivery_campaigns
                                                    .itemSelected
                                            "
                                            @update:checked="
                                                selectItemTable(
                                                    'delivery_campaigns',
                                                    item
                                                )
                                            "
                                        />
                                    </template>
                                    <template #name="{ item }">
                                        <span class="mr-2">
                                            {{ item.name }}
                                        </span>
                                        <CBadge
                                            color="warning"
                                            class="text-white"
                                            v-c-tooltip="
                                                $t(
                                                    'You need to configure a webservice to send the data'
                                                ) + '.'
                                            "
                                            v-if="!item.wsRelation"
                                        >
                                            <span>
                                                {{ $t("¡warning!") }}
                                            </span>
                                        </CBadge>
                                        <CBadge
                                            color="warning"
                                            class="text-white"
                                            v-c-tooltip="
                                                $t(
                                                    'The campaign end date has been exceeded'
                                                ) + '.'
                                            "
                                            v-if="
                                                checkIfCampaignIsFinished(item)
                                            "
                                        >
                                            <span>
                                                {{ $t("¡warning!") }}
                                            </span>
                                        </CBadge>
                                    </template>
                                    <template #active="{ item }">
                                        <CBadge
                                            v-if="stringToBoolean(item.active)"
                                            color="success"
                                            class="mr-2"
                                        >
                                            {{ $t("active") }}
                                        </CBadge>
                                        <CBadge
                                            v-else
                                            color="secondary"
                                            class="mr-2"
                                        >
                                            {{ $t("stop") }}
                                        </CBadge>
                                    </template>
                                    <template #ClientName="{ item }">
                                        <RouterLink
                                            :to="
                                                applyQueryToRoute({
                                                    route: '/app/clients',
                                                    query: {
                                                        where: {
                                                            uuid: {
                                                                equal: item.client_model_id,
                                                            },
                                                        },
                                                    },
                                                })
                                            "
                                            >{{ item.ClientName }}</RouterLink
                                        >
                                    </template>
                                    <template #dbRelation="{ item }">
                                        {{ item.dbRelation }}
                                    </template>
                                    <template #percent_ok="{ item }">
                                        <ChartGauge
                                            :value="item.percent_ok"
                                            size="sm"
                                        />
                                    </template>
                                    <template #percent_error="{ item }">
                                        <ChartGauge
                                            :value="item.percent_error"
                                            :reverse="true"
                                            size="sm"
                                        />
                                    </template>
                                    <template #percent_ko="{ item }">
                                        <ChartGauge
                                            :value="item.percent_ko"
                                            :reverse="true"
                                            size="sm"
                                        />
                                    </template>
                                    <template #percent_duplicate="{ item }">
                                        <ChartGauge
                                            :value="item.percent_duplicate"
                                            :reverse="true"
                                            size="sm"
                                        />
                                    </template>
                                    <template #capping_ok="{ item }">
                                        <span>{{ item.capping_ok }}</span>
                                    </template>

                                    <template #created_at="{ item }">
                                        {{ item.created_at.split(" ")[0] }}
                                    </template>
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                endPoint="/campaigns.api/stats"
                                                :table="
                                                    tables.delivery_campaigns
                                                "
                                            />
                                        </div>
                                    </template>
                                </CCTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.delivery_campaigns.total_pages > 0"
                            >
                                <!-- Pagination delivery campaigns -->
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="
                                            tables.delivery_campaigns.page
                                        "
                                        :pages="
                                            tables.delivery_campaigns
                                                .total_pages
                                        "
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="tables.delivery_campaigns.loading"
                                    />
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
            <NoItemsContainer
                v-show="
                    !hasItemsInTable({
                        tableName: 'delivery_campaigns',
                    })
                "
            >
                <template #title>
                    {{ $t("Create you first delivery campaign") }}
                </template>
                <template #description>
                    {{
                        $t(
                            "Start creating a delivery campaign for the leads you will send."
                        )
                    }}
                </template>
                <template #redirect>
                    <ButtonCreate
                        :title="$t('Create delivery campaign')"
                        @click="
                            $router.push({
                                name: 'view_delivery_campaings',
                            })
                        "
                    >
                        {{ $t("Create delivery campaign") }}
                    </ButtonCreate>
                </template>
                <template #cleanFilter>
                    <CButton
                        color="primary"
                        class="button"
                        v-show="
                            hasFiltersInTable({
                                tableName: 'delivery_campaigns',
                            })
                        "
                        @click="
                            cleanFiltersAdvance('delivery_campaigns'),
                                updateData()
                        "
                    >
                        <span class="button__icon">
                            <CIcon :content="$options.icons.eraser" />
                        </span>
                        <span class="button__text">
                            {{ $t("Clean filters") }}
                        </span>
                    </CButton>
                </template>
            </NoItemsContainer>
        </CCardBody>
        <CCModalUploadDeliveriesFile
            :show.sync="modals.uploadDeliveriesFile.show"
            :deliveryCampaignId="modals.uploadDeliveriesFile.data.deliveryCampaignId"
            color="primary"
            :title="$t('Upload Deliveries File')"
        ></CCModalUploadDeliveriesFile>
    </CCard>
</template>

<script>
/** Components */
import FilterDate from "~/components/FilterDate";
import ButtonCreate from "~/components/ButtonCreate";
import ChartGauge from "£lement/ChartGauge";
import TableSettings from "£lement/TableSettings";
import ButtonExport from "~/components/ButtonExport";
import FilterFields from "~/components/FilterFields";
import CCTable from "~/components/CCTable";
import NoItemsContainer from "~/components/NoItemsContainer";
import CCModalUploadDeliveriesFile from "./Components/CCModalUploadDeliveriesFile.vue";
/** Mixins */
import pageMixin from "~/mixins/page.js";
import tableMixin from "~/mixins/table.js";
import modalMixin from "~/mixins/modal.js";

/** Otheres */
import {
    cilWarning,
    cilPlus,
    cilDataTransferDown,
    cilSettings,
    cilEnvelopeClosed,
} from "@coreui/icons";
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
import DeliveryCampaignsTable from "./config/tables/delivery_campaigns";
import { eraser } from "~/assets/icons/js/eraser";
import {
    METHOD_EMAIL_CONFIGURATION,
    METHOD_SFTP_CONFIGURATION,
} from "./config/consts";


export default {
    name: "DeliveryCampaignsPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin, modalMixin],
    components: {
        FilterDate,
        ButtonCreate,
        ChartGauge,
        TableSettings,
        ButtonExport,
        FilterFields,
        CCTable,
        NoItemsContainer,
        CCModalUploadDeliveriesFile
    },
    icons: {
        cilWarning,
        cilPlus,
        cilDataTransferDown,
        cilSettings,
        cilEnvelopeClosed,
        eraser,
    },
    data() {
        return {
            tables: {
                delivery_campaigns: DeliveryCampaignsTable,
            },

            modals: {
                uploadDeliveriesFile: {
                    show: false,
                    data: {},
                },
            },
            loader: false,
        };
    },
    computed: {
        ...mapGetters({
            from: "filter/from",
            to: "filter/to",
        }),
    },
    watch: {
        "tables.delivery_campaigns.loading": {
            handler(newValue) {
                this.updatePageLoading(newValue);
            },
            deep: true,
        },
    },
    methods: {
        async updateData() {
            this.updatePageLoading(true);
            await this.updateTable({
                tableName: "delivery_campaigns",
                url: "/campaigns.api/stats",
                customFields: {
                    _selected: false,
                },
            });

            this.tables.delivery_campaigns.allFields =
                this.getTableAllFields("delivery_campaigns");
            this.tables.delivery_campaigns.itemSelected = null;
            this.updatePageLoading(false);
        },
        async reCalculateStatistics(item) {
            try {
                await this.fetcher({
                    url: `/campaigns.api/${item.uuid}/statistics/calculate`,
                    method: "PUT",
                    data: {
                        from: this.storeFrom,
                        to: this.storeTo,
                    },
                });
                this.showMessageByMethod("PUT");
                await this.updateData();
            } catch (error) {
                this.showMessageError(error);
            }
        },

        async sendEmailPassword(item) {
            try {
                this.updatePageLoading(true);
                await this.fetcher({
                    url: `/campaigns.api/${item.uuid}/workflow/method/email/password`,
                    method: "GET",
                });
                this.showMessageSuccess();
            } catch (error) {
                this.showMessageError(error);
            } finally {
                this.updatePageLoading(false);
            }
        },

        async sendWorkflowPassword(item) {
            try {
                this.updatePageLoading(true);

                switch (item.wfShippingMethodId) {
                    case METHOD_EMAIL_CONFIGURATION:
                        await this.fetcher({
                            url: `/campaigns.api/${item.uuid}/workflow/method/email/password`,
                            method: "GET",
                        });
                        break;
                    case METHOD_SFTP_CONFIGURATION:
                        await this.fetcher({
                            url: `/campaigns.api/${item.uuid}/workflow/method/sftp/password`,
                            method: "GET",
                        });
                        break;
                    default:
                        throw new Error(
                            "Shipping method not support delivery pendings"
                        );
                        break;
                }
                
                this.showMessageSuccess();
            } catch (error) {
                this.showMessageError(error);
            } finally {
                this.updatePageLoading(false);
            }
        },

        async sendEmailDeliveryPendings(item) {
            try {
                this.updatePageLoading(true);
                await this.fetcher({
                    url: `/campaigns.api/${item.uuid}/pendings/email/send`,
                    method: "GET",
                });
                this.showMessageSuccess();
            } catch (error) {
                this.showMessageError(error);
            } finally {
                this.updatePageLoading(false);
            }
        },

        async sendWorkflowPendings(item) {
            try {
                this.updatePageLoading(true);

                switch (item.wfShippingMethodId) {
                    case METHOD_EMAIL_CONFIGURATION:
                        await this.fetcher({
                            url: `/campaigns.api/${item.uuid}/pendings/email/send`,
                            method: "GET",
                        });
                        break;
                    case METHOD_SFTP_CONFIGURATION:
                        await this.fetcher({
                            url: `/campaigns.api/${item.uuid}/pendings/sftp/send`,
                            method: "GET",
                        });
                        break;
                    default:
                        throw new Error(
                            "Shipping method not support delivery pendings"
                        );
                        break;
                }

                this.showMessageSuccess();
            } catch (error) {
                this.showMessageError(error);
            } finally {
                this.updatePageLoading(false);
            }
        },
        async sendWorkflowTest(item) {
            try {
                this.updatePageLoading(true);
                await this.fetcher({
                    url: `/campaigns.api/${item.uuid}/workflow/test`,
                    method: "POST",
                    data: {
                        lead_id: 0,
                        email: "test@test.com",
                        phone: "6002623399",
                        national_phone: "6002623399",
                        first_name: "Test",
                        last_name: "Test",
                        cp: "99999",
                        origin: "test",
                        ip: "127.0.0.0",
                        home_residence: "House",
                    },
                });
                this.showMessageSuccess();
            } catch (error) {
                this.showMessageError(error);
            } finally {
                this.updatePageLoading(false);
            }
        },
        async archiveCampaign(item) {
            let result = await Swal.fire({
                title: this.$t("are_you_sure?"),
                text: this.$t("you_are_sure_to_archive_this_campaign"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: this.$t("yes,_archive_it!"),
            });
            if (result.isConfirmed) {
                const response = await this.fetcher({
                    url: `/campaigns.api/${item.uuid}/archive`,
                    method: "PUT",
                });

                this.showMessageByMethod("PUT");
                await this.updateData();
            }
        },
        async startOrStopCampaign(item) {
            const { data } = await this.sendData({
                url: "outgoing.api/setStatus",
                url_param: item.uuid,
                method: "PUT",
                data: {
                    status: !item.active,
                },
            });
            this.updateData();
        },
        async cloneCampaign(item) {

            const result = await Swal.fire({
                title: this.$t("Are you sure?"),
                text: this.$t("You are sure to clone this delivery campaign?"),
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: this.$t("Yes, clone it!"),
            });
            if (result.isConfirmed) {
                try{
                    await this.fetcher({
                    url: `campaigns.api/${item.uuid}/clone`,
                    method: "GET",
                    });
                    this.showMessageByMethod("GET");
                    this.updateData();
                } catch (error) {
                    this.showMessageError(error);
                } finally {
                    this.updatePageLoading(false);
                }
            }
                
        },
        async configureWebservice(item) {
            if (item.wsRelation) {
                this.$router.push({
                    name: "view_integration",
                    query: {
                        view_type: "edit",
                        workflow_id: item.wsRelation,
                        client_id: item.uuid,
                    },
                });
            } else {
                this.$router.push({
                    name: "view_integration",
                    query: {
                        view_type: "new",
                        client_id: item.uuid,
                    },
                });
            }
        },
        checkIfCampaignIsFinished(item) {
            let now = new Date();
            let endDate = new Date(item.end_date);
            return (
                Date.parse(now) >= Date.parse(endDate) &&
                this.stringToBoolean(item.capping_end_date)
            );
        },
    },
    beforeRouteUpdate(to, from, next) {
        this.resetFiltersInTable({
            tableName: "delivery_campaigns",
        });
        this.updateData();
        next(); // Continúa con la navegación
    },
    beforeRouteLeave(to, from, next) {
        this.resetFiltersInTable({
            tableName: "delivery_campaigns",
        });
        next();
    },
    async mounted() {
        await this.updateData();
    },
};
</script>

<style scoped lang="scss">
.icon-warning {
    color: #f9b115;
    margin-left: 0.5em;
    margin-bottom: 0.4em;
}
</style>
